export default __webpack_public_path__ + "static/media/menu.735e69af.webp";